import $ from "cash-dom";
import {storageSystem} from "./systems/storage";
import cookies from 'js-cookie';

const storage = storageSystem('cookie').createItems([
    'consentMandatory',
    'consentAnalytical',
    'consentMarketing',
    'consentAdUserData',
    'consentAdPersonalization',
]);

export const expandComponent = ($root) => {
    const $expand = $root.find('.expand');
    $expand.each((i, root) => {
        const $root = $(root);
        const $toggle = $root.find('.toggle');
        const $toggleText = $toggle.find('.toggle-text');
        const $toggleArrow = $toggle.find('.toggle-arrow');
        const $content = $root.find('.content');

        let isExpanded = false;

        $toggle.on('click', () => {
            isExpanded = !isExpanded;

            $expand.toggleClass('mb-3 mb-5');

            if (isExpanded) {
                $content.css('max-height', '9999px');
                $toggleText.text('Skryť');
                $toggleArrow.toggleClass('-scale-y-100');
            } else {
                $content.css('max-height', '0');
                $toggleText.text('Zobraziť viac');
                $toggleArrow.toggleClass('-scale-y-100');
            }
        });
    });
};

const getCookie = name => {
    const result = cookies.get(name);
    if (result === undefined)
        return false;
    return JSON.parse(result);
};

const setCookie = (name, newValue) => {
    cookies.set(name, JSON.stringify(newValue), {expires: 365});
};

export const cookieBarComponent = () => {
    const $root = $('#cookie-bar');
    const $main = $root.find('.main');
    const $options = $root.find('.options');

    if (!getCookie('consent_mandatory')) {
        $root.css('display', 'flex');
    }

    expandComponent($root);

    $main.find('.agree-all').on('click', () => {
        setCookie('consent_mandatory', true);
        setCookie('consent_analytical', true);
        setCookie('consent_marketing', true);
        setCookie('consent_ad_user_data', true);
        setCookie('consent_ad_personalization', true);

        var functionality_storage = true;
        window.dataLayer.push({
            event: 'cookie_update_consent',
            functionality_storage: 'granted',
            analytics_storage: 'granted',
            ad_storage: 'granted',
            ad_user_data: 'granted',
            ad_personalization: 'granted',
        });

        $root.css('display', 'none');
        window.location.reload();
    });

    $main.find('.disagree-all').on('click', () => {
        setCookie('consent_mandatory', true);
        setCookie('consent_analytical', false);
        setCookie('consent_marketing', false);
        setCookie('consent_ad_user_data', false);
        setCookie('consent_ad_personalization', false);

        var functionality_storage = true;
        window.dataLayer.push({
            event: 'cookie_update_consent',
            functionality_storage: 'granted',
            analytics_storage: 'denied',
            ad_storage: 'denied',
            ad_user_data: 'denied',
            ad_personalization: 'denied',
        });

        $root.css('display', 'none');
        window.location.reload();
    });

    $main.find('.open-options').on('click', () => {
        $main.css('display', 'none');
        $options.css('display', 'flex');
    });

    $options.find('.back').on('click', () => {
        $options.css('display', 'none');
        $main.css('display', 'flex');
    });

    $options.find('.agree-options').on('click', () => {
        setCookie('consent_mandatory', true);
        setCookie('consent_analytical', $('#consent_analytical').get(0).checked);
        setCookie('consent_marketing', $('#consent_marketing').get(0).checked);
        setCookie('consent_ad_user_data', $('#consent_ad_user_data').get(0).checked);
        setCookie('consent_ad_personalization', $('#consent_ad_personalization').get(0).checked);

        var functionality_storage = true;
        window.dataLayer.push({
            event: 'cookie_update_consent',
            functionality_storage: 'granted',
            analytics_storage: $('#consent_analytical').get(0).checked ? 'granted' : 'denied',
            ad_storage: $('#consent_marketing').get(0).checked ? 'granted' : 'denied',
            ad_user_data: $('#consent_ad_user_data').get(0).checked ? 'granted' : 'denied',
            ad_personalization: $('#consent_ad_personalization').get(0).checked ? 'granted' : 'denied',
        });

        $root.css('display', 'none');
        window.location.reload();
    });
};

if (!getCookie('consent_mandatory')) {
    var functionality_storage = false;
    window.dataLayer.push({
        event: 'cookie_default',
        functionality_storage: 'denied',
        analytics_storage: 'denied',
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
    });
} else {
    var functionality_storage = true;
    window.dataLayer.push({
        event: 'cookie_update_consent',
        functionality_storage: 'granted',
        analytics_storage: getCookie('consent_analytical') ? 'granted' : 'denied',
        ad_storage: getCookie('consent_marketing') ? 'granted' : 'denied',
        ad_user_data: getCookie('consent_ad_user_data') ? 'granted' : 'denied',
        ad_personalization: getCookie('consent_ad_personalization') ? 'granted' : 'denied',
    });

}

$(document).ready(() => {
    cookieBarComponent();
})
